import { Platform } from 'react-native';
import * as WebBrowser from 'expo-web-browser';
import * as Linking from 'expo-linking';

/**
 * Open a checkout URL in the best browser mode for the platform.
 * - Web: openBrowserAsync (page-sheet overlay)
 * - Native: openAuthSessionAsync (deep-link return)
 */
export async function openCheckoutSession(
  url: string,
  redirectUrl?: string,
): Promise<WebBrowser.WebBrowserResult | WebBrowser.WebBrowserAuthSessionResult> {
  const redirect = redirectUrl || Linking.createURL('/');

  if (Platform.OS === 'web') {
    return await WebBrowser.openBrowserAsync(url, {
      dismissButtonStyle: 'close',
      presentationStyle: WebBrowser.WebBrowserPresentationStyle.PAGE_SHEET,
    });
  }

  return await WebBrowser.openAuthSessionAsync(url, redirect, {
    showInRecents: true,
  });
}
